<script>
import axios from "axios";
import { TicketsPath } from "@/path";
import Swal from "sweetalert2";
import SelectWithSearch from "../../Common/SelectWithSearch.vue";

export default {
  props: ["ticket"],
  components: { SelectWithSearch },
  data() {
    return {
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      form: {
        ticket_id: this.ticket.id,
      },
    };
  },
  computed: {
    TicketsPath() {
      return TicketsPath;
    },
  },
  methods: {
    async setTransfer() {
      try {
        let res = await axios.post(
          this.base_url + TicketsPath.ASSIGN_TICKET_TO_USER,
          this.form
        );
        if (res.data.status) {
          Swal.fire("Success", "", "success");
          this.$emit("close");
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<template>
  <b-card>
    <b-card-body>
      <b-row>
        <b-col sm="12"> Ticket : # {{ ticket.ticket_id }} </b-col>
        <b-col sm="12">
          <b-form-group label="Assginee:">
            <SelectWithSearch
              :search_api="TicketsPath.SEARCH_USERS"
              track_by="id"
              display="name"
              @selectedOption="(v) => (form.user_id = v)"
            ></SelectWithSearch>
          </b-form-group>
        </b-col>
        <b-col>
          <b-button variant="success" @click="setTransfer"
            >Transfer Assignee</b-button
          >
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<style></style>
